<script setup>
import columnDefs, { components as gridComponents } from './columns'
import { useDatasource } from './useDatasource.js'
import FilterBar from '~/plugins/ag-grid/components/FilterBar.vue'
import DataTablePage from '~/plugins/ag-grid/DataTablePage.vue'

const dataTablePage = useTemplateRef('dataTablePage')
const { dataSource, count, loading, error, fetchReport } = useDatasource()

const storable = {
  source: 'appliedSettings',
  storageKey: 'reports.inventory.offer'
}

async function loadReportData (retry = false) {
  if (!retry && dataSource.allData.length) return
  await fetchReport()
}

const errorMessage = computed(() => error.value ? 'Failed to load the report.' : undefined)

watchEffect(() => {
  if (!count.value) return
  dataTablePage.value.tableFilterable.rowCount = count
})
</script>

<template>
  <DataTablePage
    ref="dataTablePage"
    title="ACV Guarantee Report"
    :column-defs="columnDefs"
    :storable="storable"
    :data-source="dataSource"
    :loading="loading"
    :has-errors="errorMessage"
    :components="gridComponents"
    @gridReady="loadReportData"
    @retry-errors="loadReportData(true)"
  >
    <template #middleBar="{ filters, resetGrid, setFilters, hasChangedState }">
      <FilterBar
        :model-value="filters"
        field="Plan"
        :has-changed-state="hasChangedState"
        :items="{ ALL: 'All', RETAIL: 'Retail', WHOLESALE: 'Wholesale', OTHER: 'Other' }"
        @update:modelValue="setFilters"
        @reset="resetGrid"
      />
    </template>
  </DataTablePage>
</template>
